// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__a03cabbadef88fe56f8e","cls2":"Comments-cls2__d35103ea1ee9cd406158 Comments-cls1__a03cabbadef88fe56f8e"};